import { InputV2 } from '@cimplico/components';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { editTableConfig } from '../../store/slice';
import { Description } from './Configurations';

type MinimumItemsProps = {
    id: string;
    defaultValue: number;
    isDisabled: boolean;
};

function MinimumItems({ id, defaultValue, isDisabled }: MinimumItemsProps): JSX.Element {
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        setValue(defaultValue);
    }, [defaultValue]);
    const dispatch = useDispatch();

    return (
        <div>
            <Description title="Minimum rows" description="The minimum number of rows required for this table." />
            <InputV2
                disabled={isDisabled}
                type="text"
                validator={(v): boolean => /[0-9]*/g.test(v)}
                value={value.toString()}
                onChange={(val): void => {
                    if (!val) {
                        setValue(0);
                    }
                    const nVal = Number(val);
                    if (!Number.isNaN(nVal)) {
                        setValue(nVal);
                    }
                }}
                onBlur={(): void => {
                    dispatch(editTableConfig({ id, minRows: value }));
                }}
            />
        </div>
    );
}

export default MinimumItems;
